import React from "react";
import backgroundImg from "../images/bg_1.jpg";

const BackgroundAndTextComponent = () => {
  return (
    <div
      className="hero-wrap js-fullheight"
      style={{
        backgroundImage: `url(${backgroundImg})`,
      }}
    >
      <div className="container">
        <div
          className="row no-gutters slider-text js-fullheight align-items-center"
          data-scrollax-parent="true"
        >
          <div className="col-md-7 ftco-animate" style={{ marginTop: 100 }}>
            <span className="subheading">Welcome to Travel Agent</span>
            <h1 className="mb-4">Discover Your Favorite Place with Us</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BackgroundAndTextComponent;
